export default __webpack_public_path__ + "static/media/datasport.6fa09761.png";